// React wrapper for Spin.js
var Spin = require("spin");

require("utility/spinner.scss")

class Spinner extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var className = "spinnerBox";

		if (this.props.center) {
			className += " center";
		}
		if (this.props.placeholder) {
			className += " placeholder";
		}

		if (this.props.className) {
			className += " " + this.props.className;
		}

		var spanProps = _.omit(this.props, "center", "placeholder", "ops",
			"scale", "className", "smallOps");

		return (
			<span { ...spanProps } className={ className } ref="spinBox"></span>
		);
	}

	componentDidMount() {
		var ops = { length: 9, radius: 6, zIndex: 1 };
		if (this.props.smallOps) {
			_.extend(ops, { width: 3, lines: 10, trail: 120, color: '#999' });
		} else {
			_.extend(ops, { width: 2, trail: 40, color: '#ccc' });
		}
		if (this.props.scale) {
			ops.length *= this.props.scale;
			ops.radius *= this.props.scale;
			ops.width *= this.props.scale;
			ops.trail *= this.props.scale;
		}
		var ops = _.extend({}, ops, this.props.ops);

		var spinner = new Spin(ops).spin(this.refs.spinBox);
	}
};

Spinner.propTypes = StrictPropTypes({
	// Class to give to the spinner wrapper
	className: PropTypes.string,

	// If this is true, center the spinner in its container
	center: PropTypes.bool,

	// If this is true, the spinner takes up space
	placeholder: PropTypes.bool,

	// If true, triggeres a different set of default ops
	smallOps: PropTypes.bool,

	// Override some default spinner ops
	ops: PropTypes.object,

	// Automatically increases the size of some default spinner ops
	scale: PropTypes.number,
});

module.exports = Spinner;


// WEBPACK FOOTER //
// ./modules/components/utility/Spinner.js